const logAnalyticsEvent = async () => { };
const getMessaging = () => ({});
const getToken = async () => '';
const deleteToken = async () => { };
const onTokenRefresh = () => () => { };
const onMessage = () => () => { };
const onNotificationOpenedApp = () => () => { };
const getInitialNotification = async () => null;
const NotificationAndroidPriority = {};
const NotificationAndroidVisibility = {};
const utils = {};
export const checkHasNotificationPermission = () => undefined;
export { utils, logAnalyticsEvent, getMessaging, getToken, deleteToken, onTokenRefresh, onMessage, onNotificationOpenedApp, getInitialNotification, NotificationAndroidPriority, NotificationAndroidVisibility, };
